import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

export default function Referral() {
  const [data, setData]     = useState(null);
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    API.post("/referral/generate")
      .then(r => setData(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const s = { minHeight:"100vh", background:"#050510", color:"#fff", fontFamily:"'DM Sans',sans-serif", padding:28 };

  if (loading) return <div style={s}><p style={{color:"#9ca3af",textAlign:"center",paddingTop:80}}>Loading...</p></div>;

  return (
    <div style={s}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&family=Syne:wght@700;900&display=swap" rel="stylesheet"/>
      <div style={{maxWidth:700, margin:"0 auto"}}>
        <button onClick={() => navigate("/dashboard")} style={{background:"transparent",color:"#9ca3af",border:"1px solid #ffffff22",borderRadius:10,padding:"8px 16px",cursor:"pointer",fontSize:13,fontFamily:"'DM Sans',sans-serif",marginBottom:24}}>← Dashboard</button>

        <div style={{textAlign:"center",marginBottom:40}}>
          <div style={{fontSize:52,marginBottom:12}}>🎁</div>
          <h1 style={{fontFamily:"'Syne',sans-serif",fontSize:32,fontWeight:900,marginBottom:8}}>Refer & Earn</h1>
          <p style={{color:"#9ca3af",fontSize:16}}>Earn 1 free month for every friend who upgrades to a paid plan</p>
        </div>

        {/* Referral link */}
        <div style={{background:"linear-gradient(135deg,#0d0d1f,#111128)",border:"1px solid #00d4aa44",borderRadius:20,padding:28,marginBottom:20}}>
          <div style={{color:"#9ca3af",fontSize:12,textTransform:"uppercase",letterSpacing:1,marginBottom:10}}>Your Referral Link</div>
          <div style={{display:"flex",gap:10,alignItems:"center",flexWrap:"wrap"}}>
            <div style={{flex:1,background:"#050510",border:"1px solid #ffffff22",borderRadius:10,padding:"12px 16px",fontSize:13,color:"#00d4aa",fontFamily:"monospace",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
              {data?.referral_link}
            </div>
            <button onClick={() => copy(data?.referral_link)} style={{background:"linear-gradient(135deg,#00d4aa,#00b894)",color:"#050510",border:"none",borderRadius:10,padding:"12px 20px",cursor:"pointer",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:14,whiteSpace:"nowrap"}}>
              {copied ? "Copied! ✓" : "Copy Link"}
            </button>
          </div>
          <p style={{color:"#6b7280",fontSize:12,marginTop:10}}>Code: <span style={{color:"#00d4aa",fontWeight:700}}>{data?.referral_code}</span></p>
        </div>

        {/* Stats */}
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:16,marginBottom:28}}>
          {[
            {icon:"👥",label:"Total Referrals",value:data?.total_referrals||0,color:"#00d4aa"},
            {icon:"💰",label:"Converted",value:data?.converted||0,color:"#a855f7"},
            {icon:"🎁",label:"Free Months Earned",value:data?.converted||0,color:"#f59e0b"},
          ].map((s,i) => (
            <div key={i} style={{background:"#0d0d1f",border:"1px solid #ffffff0a",borderRadius:16,padding:20,textAlign:"center"}}>
              <div style={{fontSize:28,marginBottom:8}}>{s.icon}</div>
              <div style={{color:"#6b7280",fontSize:11,textTransform:"uppercase",letterSpacing:1,marginBottom:4}}>{s.label}</div>
              <div style={{fontFamily:"'Syne',sans-serif",fontSize:28,fontWeight:900,color:s.color}}>{s.value}</div>
            </div>
          ))}
        </div>

        {/* How it works */}
        <div style={{background:"#0d0d1f",border:"1px solid #ffffff0a",borderRadius:20,padding:24,marginBottom:20}}>
          <h3 style={{fontFamily:"'Syne',sans-serif",fontSize:18,marginBottom:20}}>How It Works</h3>
          {[
            {step:"1",text:"Share your referral link with friends, clients, or on social media"},
            {step:"2",text:"They sign up using your link and try 2 free leads"},
            {step:"3",text:"When they upgrade to any paid plan, you earn 1 free month"},
            {step:"4",text:"No limit — refer 10 people, get 10 free months!"},
          ].map((s,i) => (
            <div key={i} style={{display:"flex",alignItems:"flex-start",gap:14,marginBottom:16}}>
              <div style={{width:28,height:28,borderRadius:"50%",background:"#00d4aa22",border:"1px solid #00d4aa44",display:"flex",alignItems:"center",justifyContent:"center",color:"#00d4aa",fontWeight:700,fontSize:13,flexShrink:0}}>{s.step}</div>
              <p style={{color:"#9ca3af",fontSize:14,lineHeight:1.6,margin:0}}>{s.text}</p>
            </div>
          ))}
        </div>

        {/* Referrals list */}
        {data?.referrals?.length > 0 && (
          <div style={{background:"#0d0d1f",border:"1px solid #ffffff0a",borderRadius:20,padding:24}}>
            <h3 style={{fontFamily:"'Syne',sans-serif",fontSize:18,marginBottom:16}}>Your Referrals</h3>
            {data.referrals.map((r,i) => (
              <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"12px 0",borderBottom:"1px solid #ffffff08"}}>
                <div style={{fontSize:14,color:"#d1d5db"}}>{r.email}</div>
                <span style={{background:r.plan!=="free"?"#00d4aa22":"#ffffff11",color:r.plan!=="free"?"#00d4aa":"#6b7280",border:"1px solid "+(r.plan!=="free"?"#00d4aa44":"#ffffff22"),borderRadius:8,padding:"3px 10px",fontSize:11,fontWeight:700}}>
                  {r.plan?.toUpperCase()||"FREE"}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
